import { IoMdSend } from "react-icons/io";
import { RiEditBoxLine } from "react-icons/ri";
import { promptMaxChars } from "../../utils/utils";
import styles from "./AiInputBox.module.css";
import { useState } from "react";
import { IoClose } from "react-icons/io5"; // for close icon
import { useMixPanelForTracking } from "../../../../Shared_utilities/trackmixpanel";

export default function AiInputBox({
  allowedPrompts,
  handleSend,
  resetChat,
  replyTo,
  setReplyTo,
  inputRef,
}) {
  const [prompt, setPrompt] = useState("");
  const {TrackMixPanel} = useMixPanelForTracking()
  const handlePromptChange = (e) => {
    setPrompt(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
       TrackMixPanel({
      "ModuleName":"lorri ai",
      "ScreenName":"chat",
      "Definition":"the user has sent a prompt",
      Data:{
        "Prompt":prompt
      }
    })
      handleSend(prompt);
      setPrompt("");
      setReplyTo(null);
    }
  };

  const handleSendClick = () => {
    TrackMixPanel({
      "ModuleName":"lorri ai",
      "ScreenName":"chat",
      "Definition":"the user has sent a prompt",
      Data:{
        "Prompt":prompt
      }
    })
    handleSend(prompt);
    setPrompt("");
    setReplyTo(null);
  };

  return (
    <div className={styles.promptUtils}>
      <div className={styles.InputContainerWrapper}>
        {replyTo && (
          <div className={styles.replyPreview}>
            <span className={styles.replyLabel}>
              <i className="fa fa-reply mr-1" aria-hidden="true" /> {replyTo}
            </span>
            <button
              className={styles.clearReplyBtn}
              onClick={() => setReplyTo(null)}
            >
              <IoClose size={16} />
            </button>
          </div>
        )}

        <div className={styles.InputContainer}>
          <input
            ref={inputRef}
            type="text"
            placeholder="Ask a question..."
            value={prompt}
            onChange={handlePromptChange}
            onKeyDown={handleKeyDown}
            className={styles.InputField}
            autoFocus
          />
          <div
            className={`${styles.Counter} ${
              prompt.length > promptMaxChars ? "text-danger" : ""
            }`}
          >
            {prompt.length}/{promptMaxChars}
          </div>
          <button
            disabled={allowedPrompts === 0}
            className={styles.SendButton}
            onClick={handleSendClick}
          >
            <IoMdSend size={17} />
          </button>
          <button
            className={styles.newChatButton}
            title="New Chat"
            onClick={()=>{
              resetChat()
              TrackMixPanel({
                Definition:"user has clicked on the reset chat button.",
                ModuleName:"lorri ai",
                ScreenName:"chat",
              })
            }}
          >
            <RiEditBoxLine size={17} />
          </button>
        </div>
      </div>
    </div>
  );
}
